import { Link, useParams } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { PlanFullScreen } from '../components/PlanPicker.js';
import { buildTitle, useDocumentTitle } from '../lib/use-document-title.js';

export function PlanScreen() {
  const { projectId } = useParams<{ projectId: string }>();
  useDocumentTitle(buildTitle('План'));

  if (!projectId) return null;

  return (
    <div className="p-4 space-y-4 max-w-2xl mx-auto pb-24">
      <header className="flex items-center pt-2">
        <Link
          to={`/projects/${projectId}`}
          className="inline-flex items-center text-neutral-400 hover:text-neutral-200"
        >
          <ChevronLeft className="w-5 h-5" /> <span className="text-sm">Назад</span>
        </Link>
      </header>

      <PlanFullScreen projectId={projectId} />
    </div>
  );
}
